"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedOptionResponseExceptCategory = exports.mockedOptionResponse = void 0;
const omit_util_1 = require("../../utils/omit.util");
const option_category_1 = require("../option-category");
exports.mockedOptionResponse = {
  id: 1,
  category: option_category_1.mockedOptionCategoryResponseExceptOptions,
  name: {
    id: 1,
    en: 'en',
    ru: 'rxu'
  }
};
exports.mockedOptionResponseExceptCategory = omit_util_1.omitObject(exports.mockedOptionResponse, 'category');